import ResetPasswordVerrifyCode from './ResetPasswordVerifyCode'

export default ResetPasswordVerrifyCode
